import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "10 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"10 0 128 128\" id=\"facebook\"><path fill=\"currentColor\" d=\"M93.376 117.012H72.203V65.767H61.625v-17.66h10.578V37.504c0-14.407 5.973-22.974 22.943-22.974h14.128v17.662h-8.83c-6.607 0-7.044 2.468-7.044 7.074l-.024 8.84h15.998l-1.872 17.66H93.376v51.246z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol